module.exports = __webpack_public_path__ + "img/couples-081.f994f1e3.jpg";